































import { computed, defineComponent, ref, useContext } from '@nuxtjs/composition-api';

/* @ts-ignore */
import fallbackImage from '@/assets/images/Kamera_Express_faded_logo.webp';

export default defineComponent({
  name: 'ImageOrFallback',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    sizes: {
      type: String
    },
    loading: {
      type: String,
      default: 'lazy'
    },
    fit: {
      type: String,
      default: 'contain'
    }
  },
  setup(props) {
    const { $config } = useContext();

    const isImageValid = ref(true);

    const handleBrokenImage = () => {
      isImageValid.value = false;
    };

    const mediaUrl = (path) => {
      if (
        path.startsWith('https://') ||
        path.startsWith('http://') ||
        path.startsWith('/_nuxt/') ||
        path.startsWith('data:') ||
        path.startsWith('blob:')
      ) {
        return path;
      }
      return `${$config.mediaBaseURL}${path}`;
    };

    const roundDimension = (value) => {
      if (typeof value !== 'number' || Number.isNaN(value) || value <= 0) {
        return undefined;
      }
      return Math.round(value);
    };

    const roundedWidth = computed(() => roundDimension(props.width));
    const roundedHeight = computed(() => roundDimension(props.height));

    return {
      handleBrokenImage,
      mediaUrl,
      fallbackImage,
      isImageValid,
      roundedWidth,
      roundedHeight
    };
  }
});
